import get from '../helpers/get';

// eslint-disable-next-line import/prefer-default-export
export const isProductWishlisted = (state, sku) => !!get(state, ['wishlist', 'skus', sku]);
